import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getAllPosts, formatPostDate } from "@/lib/posts";

export default function Blog() {
  const posts = getAllPosts();

  return (
    <div data-testid="page-blog">
      <section className="container-refined pt-16 md:pt-24 pb-8">
        <div className="max-w-3xl animate-fade-up">
          <span className="eyebrow">Notes from The Refinery</span>
          <h1 className="font-serif mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            Slow, honest writing for the men who don&rsquo;t say it out loud.
          </h1>
          <p className="font-script text-4xl mt-3">Where You&rsquo;re Heard.</p>
          <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed" style={{ color: "#2A2621" }}>
            Short reads on burnout, purpose, provider fatigue, and the quiet interior work most men
            never get to have. Read one when you have a minute to yourself.
          </p>
        </div>
      </section>

      <section className="container-refined pb-24" data-testid="blog-list">
        <div className="grid gap-6 md:gap-8 md:grid-cols-2">
          {posts.map((post) => (
            <PostCard key={post.slug} post={post} />
          ))}
        </div>
      </section>
    </div>
  );
}

function PostCard({ post }) {
  return (
    <article
      data-testid={`blog-card-${post.slug}`}
      className="rounded-2xl border p-7 md:p-8 flex flex-col transition-all hover:-translate-y-1"
      style={{
        background: "#FAF6EC",
        borderColor: "rgba(201,168,76,0.55)",
        boxShadow: "0 30px 60px -30px rgba(27,67,50,0.28)",
      }}
    >
      <span className="text-xs tracking-[0.22em] uppercase" style={{ color: "#6E6759" }}>
        {formatPostDate(post.date)}
      </span>
      <h2
        className="font-serif mt-3 text-2xl md:text-3xl leading-tight"
        style={{ color: "#1B4332" }}
      >
        {post.title}
      </h2>
      <p className="mt-4 text-[15px] leading-relaxed flex-1" style={{ color: "#2A2621" }}>
        {post.excerpt}
      </p>
      <Link
        to={`/blog/${post.slug}`}
        data-testid={`blog-read-more-${post.slug}`}
        className="mt-6 inline-flex items-center gap-2 font-medium text-sm tracking-wide"
        style={{ color: "#C9A84C" }}
      >
        Read more <ArrowRight size={14} />
      </Link>
    </article>
  );
}
